module.exports = __webpack_public_path__ + "img/resourceHead.335b1ab9.png";